import { Outlet } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';

// project import
import Header from './Header';
import Drawer from './Drawer';

import useConfig from 'hooks/useConfig';
import { useState } from 'react';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {

  const { container } = useConfig();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(true);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      <Drawer drawerOpen={drawerOpen} />
      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, pt: {xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: 'inherit' }} />
        <Container
          maxWidth={container ? 'xl' : false}
          sx={{
            ...(container && { px: { xs: 0, sm: 2 } }),
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
}
